import {createAction, props} from '@ngrx/store';
import {Belegart} from '../../util/belegart.enum';


export class VersandstatusHistoryDialogActions {

  public static open = createAction(
    '[Versandstatus History Dialog] Open versandstatus history dialog.',
    props<{
      betriebId: string;
      belegId: string;
      belegnummer: string;
      belegart: Belegart;
    }>(),
  );

  public static close = createAction(
    '[Versandstatus History Dialog] Close versandstatus history dialog.',
  );
}
